import { Navigate } from 'react-router';
import { useAppSelector } from '../../redux/hooks.ts';
import { selectIsInspectifyOrder } from '../../redux/features/selectors/orderSelectors.ts';

export const InspectifyGuard = ({ children }: React.PropsWithChildren) => {
  const isInspectifyOrder = useAppSelector(selectIsInspectifyOrder);

  if (!isInspectifyOrder) {
    return <Navigate to="/" />;
  }
  return children;
}
